<!-- Usuarios del reporte de sostenibilidad (ui-redesign): lectura (kv foto+nombre) /
     edición (app-user-search .ds). -->
<form [formGroup]="getCentroUserReportFormGroup()" class="cards">
  <div class="card-row">
    <!-- ============ INTRODUCCIÃ“N DE DATOS ============ -->
    <div class="card">
      <div class="sec-head">
        <span class="sec-tile purple"><mat-icon>group</mat-icon></span>
        <div>
          <h3>{{ "centro.centroData.dataIntro" | translate }}</h3>
          <p>{{ "centro.centroData.usersReportSostenibility" | translate }}</p>
        </div>
      </div>

      <!-- Introductor de datos -->
      <div class="urc-row">
        <div class="kv-k">{{ "centro.centroData.generalInputs" | translate }}</div>
        <div class="resp-view" *ngIf="!(parent?.isEditing || parent?.isCreating)">
          <app-empleado-display [empleado]="parent?.responsableReporteControl?.value"></app-empleado-display>
        </div>
        <div class="urc-edit" *ngIf="parent?.isEditing || parent?.isCreating">
          <app-user-search
            [users]="parent.employees"
            [label]="'centro.centroData.generalInputs' | translate"
            [placeholder]="'shared.refineSearch' | translate"
            [tooltip]="'centro.centroData.tooltipIntroductorDatos' | translate"
            [value]="parent.responsableReporteControl.value"
            (userSelected)="parent.onReporteSelected($event)"
          ></app-user-search>
        </div>
      </div>

      <!-- Introductor ambiental -->
      <div class="urc-row">
        <div class="kv-k">{{ "centro.centroData.generalInputs2" | translate }}</div>
        <div class="resp-view" *ngIf="!(parent?.isEditing || parent?.isCreating)">
          <app-empleado-display [empleado]="parent?.introductorAmbientalControl?.value"></app-empleado-display>
        </div>
        <div class="urc-edit" *ngIf="parent?.isEditing || parent?.isCreating">
          <app-user-search
            [users]="parent.employees"
            [label]="'centro.centroData.generalInputs2' | translate"
            [placeholder]="'shared.refineSearch' | translate"
            [value]="parent.introductorAmbientalControl.value"
            (userSelected)="parent.onAmbientalSelected($event)"
          ></app-user-search>
        </div>
      </div>

      <!-- Introductor social -->
      <div class="urc-row">
        <div class="kv-k">{{ "centro.centroData.socialInput" | translate }}</div>
        <div class="resp-view" *ngIf="!(parent?.isEditing || parent?.isCreating)">
          <app-empleado-display [empleado]="parent?.introductorSocialControl?.value"></app-empleado-display>
        </div>
        <div class="urc-edit" *ngIf="parent?.isEditing || parent?.isCreating">
          <app-user-search
            [users]="parent.employees"
            [label]="'centro.centroData.socialInput' | translate"
            [placeholder]="'shared.refineSearch' | translate"
            [tooltip]="'centro.centroData.tooltipIntroductorDatosSocial' | translate"
            [value]="parent.introductorSocialControl.value"
            (userSelected)="parent.onSocialSelected($event)"
          ></app-user-search>
        </div>
      </div>
    </div>

    <!-- ============ VALIDACIÃ“N DE DATOS ============ -->
    <div class="card">
      <div class="sec-head">
        <span class="sec-tile blue"><mat-icon>verified</mat-icon></span>
        <div>
          <h3>{{ "centro.centroData.dataValidation" | translate }}</h3>
          <p>{{ "centro.centroData.usersReportSostenibility" | translate }}</p>
        </div>
      </div>

      <!-- Validador principal -->
      <div class="urc-row">
        <div class="kv-k">{{ "centro.centroData.mainValidator" | translate }}</div>
        <div class="resp-view" *ngIf="!(parent?.isEditing || parent?.isCreating)">
          <app-empleado-display [empleado]="parent?.validadorPrincipalControl?.value"></app-empleado-display>
        </div>
        <div class="urc-edit" *ngIf="parent?.isEditing || parent?.isCreating">
          <app-user-search
            [users]="parent.employees"
            [label]="'centro.centroData.mainValidator' | translate"
            [placeholder]="'shared.refineSearch' | translate"
            [value]="parent.validadorPrincipalControl.value"
            (userSelected)="parent.onValPrincipalSelected($event)"
          ></app-user-search>
        </div>
      </div>

      <!-- Validador de apoyo -->
      <div class="urc-row">
        <div class="kv-k">{{ "centro.centroData.supportValidator" | translate }}</div>
        <div class="resp-view" *ngIf="!(parent?.isEditing || parent?.isCreating)">
          <app-empleado-display [empleado]="parent?.validadorApoyoControl?.value"></app-empleado-display>
        </div>
        <div class="urc-edit" *ngIf="parent?.isEditing || parent?.isCreating">
          <app-user-search
            [users]="parent.employees"
            [label]="'centro.centroData.supportValidator' | translate"
            [placeholder]="'shared.refineSearch' | translate"
            [value]="parent.validadorApoyoControl.value"
            (userSelected)="parent.onValApoyoSelected($event)"
          ></app-user-search>
        </div>
      </div>

      <input type="hidden" formControlName="fechaValidacion" [value]="this.centro.fechaValidacion" />
    </div>
  </div>
</form>
